import { InfoOutlined } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"


const InfoTooltip = ({ info, color }: { info: string, color?: string }) => (
  <Box display="flex" gap={1} pt={1} sx={{ minHeight: '55px' }}>
    <InfoOutlined sx={{ fontSize: '16px', color: '#000000' }} />
    <Typography variant="caption" color={color ||'#000000'}>
      {info}
    </Typography>
  </Box>
)

export default InfoTooltip